<!--SKU编辑  -->
<template>
	<div class="dialogBox">
		<el-dialog title="选择车辆" v-if="dialogVisible" :visible.sync="dialogVisible" :close-on-click-modal="false"
			:close-on-press-escape="false" :modal-append-to-body="false" width="800px" :before-close="cancle">
			<span slot="title" class="flex flex-middle">
				<div class="title">选择线路员</div>
				<div class="flex ml15">
					<el-input v-model.trim="userName" class="w190" size="small" placeholder="姓名" maxlength="16"
						clearable>
					</el-input>
					<img class="icon-img ml10" src="@/assets/images/search.png" @click="handleSearch" alt="">
				</div>
			</span>
			<div class="form-box">
				<el-table v-if="tableData.length > 0" class="" ref="multipleTable" v-el-table-infinite-scroll="tableLoad" :data="tableData"
					height="320" :header-cell-style="{background:'rgba(200, 204, 215,.6)',color:'#333333'}"
					@row-click="handleRowClick" border style="width: 100%">
					<el-table-column width="60" label="选择" align="center">
						<template slot-scope="scope">
							<el-radio v-model="selecteId" :label="Number(scope.row.dataKey)" @change="radioRow(scope.row)">
							</el-radio>
						</template>
					</el-table-column>
					<el-table-column v-show="tableData" v-for="(value, index) in titles" :key="index"
						:show-overflow-tooltip="true" :label="value.title" :min-width="value.maxWidth">
						<template slot-scope="scope">
							{{scope.row.datas[index]}}
						</template>
					</el-table-column>
				</el-table>
				<div v-else class="tc mt15">暂无数据</div>
			</div>
			<span slot="footer" class="dialog-footer mt10">
				<el-button size="small" @click="cancle()">取 消</el-button>
				<el-button size="small" type="primary" @click="submitForm()">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		debounce
	} from '@/utils/debounce'
	export default {
		data() {
			return {
				dialogVisible: false,
				userName: "",
				tableData: [],
				titles: [],
				pageNo: 1,
				pageSize: 20,
				totalPage: 0,
				multipleSelection: [],
				selecteId: '',
				flag: "",
				groupId: "",
				infiniteFlag: false,
			}
		},
		created() {

		},
		methods: {
			init(flag, dt) {
				this.$nextTick(() => {
					this.dialogVisible = true
					this.pageNo = 1
					this.infiniteFlag = false
					this.groupId = dt.groupId
					this.userName = ""
					this.getList()
					if(flag == 1) {
						this.selecteId = dt.mainUserId ? dt.mainUserId : '';
					}else {
						this.selecteId = dt.secUserId ? dt.secUserId : '';
					}
					this.flag = flag
					console.log(dt)
				})
			},
			// 获取用户列表
			getList(type) {
				if(this.infiniteFlag) {
					return
				}
				let that = this;
				that.$request.post(
						"groupUserListPage",
						false, {
							pageNo: that.pageNo,
							pageSize: that.pageSize,
							userName: that.userName,
							groupId: that.groupId,
							userStatus: 0
						}
					)
					.then((res) => {
						if(res.data) {
							that.infiniteFlag = res.data.totalPage <= that.pageNo;
							}
						if (type == 'scroll') {
							that.tableData = that.tableData.concat(res.data && res.data.tableDatas || []);
						} else {
							if (res.data && res.data.tableDatas.length > 0) {
								that.titles = res.data.titles
								that.tableData = res.data.tableDatas
							} else {
								that.titles = []
								that.tableData = []
							}
						}

					})
			},

			// 表格滚动加载
			tableLoad: debounce(function () {
				this.pageNo++;
				this.getList('scroll');
			}, 100, true),
			// 当前页切换
			handleCurrentChange(val) {
				this.pageNo = val;
				this.getList();
			},
			// 搜索
			handleSearch() {
				if(this.tableData.length > 0){
					this.$refs.multipleTable.clearSelection();
					this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
				}

				this.pageNo = 1;
				this.infiniteFlag = false;
				this.$nextTick(() => {
					this.getList();
				})
			},

			// 列单选
			radioRow(val) {
				this.multipleSelection = [];
				this.multipleSelection.push(val)
			},
			// 点击行选中
			handleRowClick(row, column, event) {
				this.selecteId = Number(row.dataKey);
				this.multipleSelection = [];
				this.multipleSelection.push(row)
			},
			// 保存
			submitForm: debounce(function () {
				this.$emit("selectUserRows", this.multipleSelection)
				this.$emit("flag", this.flag)
				this.$emit("clearReadonly")
				this.dialogVisible = false
			}, 1000, true),
			// 取消
			cancle() {
				this.$emit("clearReadonly")
				this.dialogVisible = false
			},
		},
		beforeDestroy() {

		}
	}

</script>
<style lang='scss' scoped>
	.dialogBox {

		/deep/ .el-dialog__body {
			padding: 0px 10px;
		}

		/deep/ .el-radio .el-radio__label {
			display: none;
		}
	}

	.el-dialog__body {
		height: 500px;
	}

	.el-table {

		// 深度选择器，去除默认的padding
		/deep/ th {
			padding: 5px;
		}

		/deep/ td {
			padding: 5px;
		}

	}

</style>
